import axios from 'axios';
import { constants } from '../constants';
const axiosInstance = axios.create({
  baseURL: `${constants.API_BASE}`, // Backend ngrok URL
  withCredentials: true, // ✅ Allow sending cookies
});

// Automatically attach the token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const tokenData = JSON.parse(localStorage.getItem('token'));
    const token = tokenData?.value;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Redirect on auth error
    if (error.response?.status === 401) {


      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
